import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import FrontLayout from '@/frontLayout'

export const constantRoutes = [
  {
    path: '/',
    component: FrontLayout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        component: () => import('@/views/home/index'),
        meta: { title: 'Home' },
        hidden: true
      }
    ]
  },
  {
    path: '/article',
    component: FrontLayout,
    children: [
      {
        path: '/article',
        component: () => import('@/views/article/index'),
        meta: { title: 'Article' },
        hidden: true
      }
    ]
  },
  {
    path: '/consortia',
    component: FrontLayout,
    children: [
      {
        path: '/consortia',
        component: () => import('@/views/consortia/index'),
        meta: { title: 'Consortia' },
        hidden: true
      }
    ]
  },
  {
    path: '/conference',
    component: FrontLayout,
    children: [
      {
        path: '/conference',
        component: () => import('@/views/conference/index'),
        meta: { title: 'Conference' },
        hidden: true
      }
    ]
  },
  {
    path: '/conf',
    component: FrontLayout,
    children: [
      {
        path: '/conf',
        component: () => import('@/views/conf/summercamp2026/index'),
        meta: { title: 'Summer Camp 2026' },
        hidden: true
      }
    ]
  },
  {
    path: '/conf/bigbrain',
    component: FrontLayout,
    children: [
      {
        path: '/conf/bigbrain',
        component: () => import('@/views/conf/bigbrain/index'),
        meta: { title: 'Big Brain Conference' },
        hidden: true
      }
    ]
  },
  {
    path: '/conf/xishuangbanna',
    component: FrontLayout,
    children: [
      {
        path: '/conf/xishuangbanna',
        component: () => import('@/views/conf/xishuangbanna/index'),
        meta: { title: 'xishuangbanna' },
        hidden: true
      }
    ]
  },
  {
    path: '/conf/summer',
    component: FrontLayout,
    children: [
      {
        path: '/conf/summer',
        component: () => import('@/views/conf/summercamp/index'),
        meta: { title: 'Summer Camp 2022' },
        hidden: true
      },
      {
        path: '/conf/summer2026',
        component: () => import('@/views/conf/summercamp2026/index'),
        meta: { title: 'Summer Camp 2026' },
        hidden: true
      },
      {
        path: '/conf/summer2025',
        component: () => import('@/views/conf/summercamp2025/index'),
        meta: { title: 'Summer Camp 2025' },
        hidden: true
      },
      {
        path: '/conf/summer2024',
        component: () => import('@/views/conf/summercamp2024/index'),
        meta: { title: 'Summer Camp 2024' },
        hidden: true
      },
      {
        path: '/conf/summer2023',
        component: () => import('@/views/conf/summer2023/index'),
        meta: { title: 'Summer Camp 2023' },
        hidden: true
      }
    ]
  },
  {
    path: '/software',
    component: FrontLayout,
    children: [
      {
        path: '/software',
        component: () => import('@/views/software/index'),
        meta: { title: 'Software' },
        hidden: true
      }
    ]
  },
  {
    path: '/database',
    component: FrontLayout,
    children: [
      {
        path: '/database',
        component: () => import('@/views/database/index'),
        meta: { title: 'Database' },
        hidden: true
      }
    ]
  },
  {
    path: '/people',
    component: FrontLayout,
    children: [
      {
        path: '/people',
        component: () => import('@/views/people/index'),
        meta: { title: 'People' },
        hidden: true
      }
    ]
  },
  {
    path: '/people/detail',
    name: 'people.detail',
    component: FrontLayout,
    children: [
      {
        path: '/people/detail',
        component: () => import('@/views/people/detail'),
        meta: { title: 'People Detail' },
        hidden: true
      }
    ]
  },
  {
    path: '/news',
    component: FrontLayout,
    children: [
      {
        path: '/news',
        component: () => import('@/views/news/index'),
        meta: { title: 'News' },
        hidden: true
      }
    ]
  },
  {
    path: '/news/detail',
    name: 'news.detail',
    component: FrontLayout,
    children: [
      {
        path: '/news/detail',
        component: () => import('@/views/news/detail'),
        meta: { title: 'News Detail' },
        hidden: true
      }
    ]
  },
  {
    path: '/about',
    component: FrontLayout,
    children: [
      {
        path: '/about',
        component: () => import('@/views/about/index'),
        meta: { title: 'About' },
        hidden: true
      }
    ]
  },
  {
    path: '/events',
    component: FrontLayout,
    children: [
      {
        path: '/events',
        component: () => import('@/views/events/index'),
        meta: { title: 'events' },
        hidden: true
      }
    ]
  },
  {
    path: '/about/data',
    component: FrontLayout,
    children: [
      {
        path: '/about/data',
        component: () => import('@/views/about/data'),
        meta: { title: 'Data' },
        hidden: true
      }
    ]
  },
  {
    path: '/login',
    component: FrontLayout,
    children: [
      {
        path: '/login',
        component: () => import('@/views/login/index'),
        meta: { title: 'Login' },
        hidden: true
      }
    ]
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },

  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
